import { environment } from "src/environments/environment";
import { DgMenuItem } from "../common/menu/types";
import { urlJoin } from "../core/common/public";

export const HEADER_ITEMS :DgMenuItem[] = [
    {
        title: 'دادخواست ها',
        isHeaderItem: true,
        children: [
            {
                title: 'دادخواست آماده',
                link: urlJoin(environment.djangoUrl, 'petition/ready')
            },
            {
                title: 'سفارش دادخواست',
                link: urlJoin(environment.djangoUrl, 'petition/custom')
            },
            {
                title: 'دادخواست هوشمند',
                link: urlJoin(environment.djangoUrl, 'petition/smart')
            }
        ]
    },
    {
        title: 'قراردادها',
        isHeaderItem: true,
        children: [
            {
                title: 'قرارداد آماده',
                link: urlJoin(environment.djangoUrl, 'contract/ready')
            },
            {
                title: 'سفارش قرارداد',
                link: urlJoin(environment.djangoUrl, 'contract/custom')
            },
            {
                title: 'قرارداد هوشمند',
                link: urlJoin(environment.djangoUrl, 'contract/smart')
            },
            {
                title: 'کارشناسی قرارداد',
                link: 'contract-user/create-expertise-contract',
            },
            {
                title: 'حضور در جلسه قرارداد',
                link: 'contract-user/create-contract-meeting',
            }
        ]
    },
    {
        title: 'شکوائیه‌ها',
        isHeaderItem: true,
        children: [
            {
                title: 'شکوائیه آماده',
                link: urlJoin(environment.djangoUrl, 'complaint/ready')
            },
            {
                title: 'سفارش شکوائیه',
                link: urlJoin(environment.djangoUrl, 'complaint/custom')
            },
            {
                title: 'شکوائیه هوشمند',
                link: urlJoin(environment.djangoUrl, 'complaint/smart')
            },
        ]
    },
    {
        title: 'اوراق قضایی',
        isHeaderItem: true,
        link: urlJoin(environment.djangoUrl, 'judicial/')
        // children: [
        //     {
        //         title: 'تنظیم یا کارشناسی لایحه',
        //         link: 'judicial-user/create-bill'
        //     },
        //     {
        //         title: 'تنظیم یا کارشناسی اظهارنامه',
        //         link: 'judicial-user/create-declaration',
        //     },
        //     {
        //         title: 'سایر درخواست‌ها',
        //         link: 'judicial-user/create-other-request',
        //     },
        // ]
    },
    {
        title: 'مشاوره',
        isHeaderItem: true,
        link: urlJoin(environment.djangoUrl, 'consultation/')
    },
    {
        title: 'آموزش',
        isHeaderItem: true,
        link: urlJoin(environment.djangoUrl, 'edu-list/')
    },
    {
        title: 'بسته حقوقی',
        isHeaderItem: true,
        link: 'package-user/create-package'
    },
    {
        title: 'درباره ما',
        isHeaderItem: true,
        link: urlJoin(environment.djangoUrl, 'aboutus/')
    },
    {
        title: 'ارتباط با ما',
        isHeaderItem: true,
        link: urlJoin(environment.djangoUrl, 'contact-us/')
    }
]